import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=022ebdf8&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ebdf8",
  null
  
)

export default component.exports